<div [ngClass]="{'blocked': userData && userData.Status && userData.Status === '4'}" [ngStyle]="{'visibility': notHideNavOnLoad ? 'visible' : 'hidden'}" [class.toggleContent]="!toggleContent" class="awesomeNavigation {{routerForNavbar}} {{language}}" *ngIf="!lotteryService.isTablet && !lotteryService.isMobile">
  <div class="suspInfo" *ngIf="userData && userData.Status && userData.Status === '4'">{{'nav.suspInfo1' | translate }} <span (click)="userService.checkStatus(userData.Status)">{{'nav.suspInfo2' | translate }}</span> </div>
  <div class="leftSide" #leftSide>
  <div class="logo"><a routerLink="/" (click)="hideRegModal();"></a></div>
  <div class="nav-element nav-lotteries">
    <a [ngClass]="{'active': activeRouteParameters('/lotteries', '/lotteries-results')}"
       [routerLink]="[language ? language : 'en', 'lotteries']">

      <span class="ico ico-lotteries ico-lotteries-{{language}}">
        <img *ngIf="brand === 'qiwi'" src="../../../assets/images/navigation/icons/Lotto/FullColor.svg" width="20px" height="20px" />
        <img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/Lotto/FullColor-Winaija.svg" width="20px" height="20px" />
      </span>
      <span class="text">{{ 'awesomeNav.lotteries' | translate }}</span>
    </a>
    <span class="extendLotteries">
    <span class="triangle"></span>
      <div *ngIf="brand === 'qiwi'" class="add-lottery powerballMenu">
        <a [ngClass]="{'active': activeRouteParameters('/lotteries/powerball', '/lotteries-results/powerball')}"
               [routerLink]="[language ? language : 'en', 'lotteries', 'powerball']">
            <span class="text lottery-powerball">Powerball</span>
        </a>
        <div class="tooltipBoxWrapper tooltipBox-powerball">
            <div class="tooltipBox">
              <div class="tooltipBody">
                  <div class="lottery-time">
                    <img src="../../../assets/images/fancy-banner/clock-grey.svg" />
                    <app-universalcounter [lottery]="4">{{ 'carousel.loading' | translate }}</app-universalcounter>
                  </div>
                <div class="logo-icon logoPowerball"><img src="../../../assets/images/lotteries/powerball/icons/powerball_50x50.png" /></div>
                  <div class="jackpot" *ngIf="powerballBundle && powerballBundle[0] && powerballBundle[0].Rates && currency && currency.Code && jackpotConfig.downloadedData">{{powerballBundle[0].Rates.TotalJackpotAmount[currency.Code] | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en') | jackpot: (subscriptionsService.countryCodeValue || 'en'):currency.Symbol:language:false}}</div>
                <hr>
                  <div *ngIf="powerballBundle && currency && currency.Code" class="middle-lottery-information">
                            <button *ngFor="let offer of powerballBundle" class="przycisk medium green rectangle-btn lottery" [ngClass]="{'disabled-btn' : getIsLoading(offer.Name)}"
                                 (click)="buyPackage(
                                   offer.Items[0].Lottery.ID,
                                   'powerball',
                                   'Powerball',
                                   offer.Items[0].NumberOfEntries,
                                   offer.Rates.OnlinePrice[currency.Code],
                                   offer.PackageID,
                                   offer.Name
                                   );">
                                <div class="cart"></div>
                              <div class="price"><div class="cartIcon"><img *ngIf="brand === 'qiwi'" src="../../../assets/images/navigation/icons/ic-cart.svg" /><img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/ic-cart-winaija.svg" /></div>{{offer.Items[0].NumberOfEntries}} {{ 'lt.lt10' | translate }} {{ 'scratchcards.for' | translate }} {{offer.Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}</div>
                                  <span *ngIf="getIsLoading(offer.Name);" class="spinner"></span>
                            </button>
                    <div class="choose-numbers"><a [routerLink]="[language ? language : 'en', 'lotteries', 'powerball']">{{ 'lt.lt3' | translate }}</a></div>
                  </div>

              </div>
            </div>
        </div>
      </div>

      <div *ngIf="brand === 'qiwi'" class="add-lottery eurojackpotMenu">
        <a [ngClass]="{'active': activeRouteParameters('/lotteries/eurojackpot', '/lotteries-results/eurojackpot')}"
           [routerLink]="[language ? language : 'en', 'lotteries', 'eurojackpot']">
          <span class="text lottery-eurojackpot">EuroJackpot</span>
        </a>
        <div class="tooltipBoxWrapper tooltipBox-eurojackpot">
            <div class="tooltipBox">
              <div class="tooltipBody">
                  <div class="lottery-time">
                    <img src="../../../assets/images/fancy-banner/clock-grey.svg" />
                    <app-universalcounter [lottery]="33">{{ 'carousel.loading' | translate }}</app-universalcounter>
                  </div>
                <div class="logo-icon logoEurojackpot"><img src="../../../assets/images/lotteries/eurojackpot/icons/eurojackpot_50x50.png" /></div>
                  <div class="jackpot" *ngIf="eurojackpotBundle && eurojackpotBundle[0] && eurojackpotBundle[0].Rates && currency && currency.Code && jackpotConfig.downloadedData">{{eurojackpotBundle[0].Rates.TotalJackpotAmount[currency.Code] | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en') | jackpot: (subscriptionsService.countryCodeValue || 'en'):currency.Symbol:language:false}}</div>
                <hr>
                  <div *ngIf="eurojackpotBundle && currency && currency.Code" class="middle-lottery-information">
                            <button *ngFor="let offer of eurojackpotBundle" class="przycisk green medium rectangle-btn lottery" [ngClass]="{'disabled-btn' : getIsLoading(offer.Name)}"
                                    (click)="buyPackage(
                                   offer.Items[0].Lottery.ID,
                                   'eurojackpot',
                                   'Eurojackpot',
                                   offer.Items[0].NumberOfEntries,
                                   offer.Rates.OnlinePrice[currency.Code],
                                   offer.PackageID,
                                   offer.Name
                                   );">
                                <div class="cart"></div>
                                <div class="price"><div class="cartIcon"><img *ngIf="brand === 'qiwi'" src="../../../assets/images/navigation/icons/ic-cart.svg" /><img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/ic-cart-winaija.svg" /></div>{{offer.Items[0].NumberOfEntries}} {{ 'lt.lt10' | translate }} {{ 'scratchcards.for' | translate }} {{offer.Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}</div>
                                  <span *ngIf="getIsLoading(offer.Name);" class="spinner"></span>
                            </button>
                    <div class="choose-numbers"><a [routerLink]="[language ? language : 'en', 'lotteries', 'eurojackpot']">{{ 'lt.lt3' | translate }}</a></div>
                  </div>

              </div>
            </div>
        </div>
      </div>


       <div *ngIf="brand === 'winaija'" class="add-lottery winaijaWinner powerballMenu ">
        <a [ngClass]="{'active': activeRouteParameters('/winner', '/lotteries-results/winner')}"
           [routerLink]="[language ? language : 'en', 'winner']">
            <span class="text lottery-powerball">Winner</span>
        </a>
        <div class="tooltipBoxWrapper tooltipBox-powerball tooltipWinner">
            <div class="tooltipBox">
              <div class="tooltipBody">
                  <div class="lottery-time">
                    <img src="../../../assets/images/fancy-banner/clock-grey.svg" />
                    <app-universalcounter [lottery]="41">{{ 'carousel.loading' | translate }}</app-universalcounter>
                  </div>
                <div class="logo-icon logoPowerball winnerLogo"><img src="../../../assets/images/lotteries/winner/icons/winner_50x50.png" /></div>
                  <div class="jackpot" *ngIf="winnersBundle && winnersBundle[0] && winnersBundle[0].Rates && currency && currency.Code && jackpotConfig.downloadedData">{{winnersBundle[0].Rates.TotalJackpotAmount[currency.Code] | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en') | jackpot: (subscriptionsService.countryCodeValue || 'en'):currency.Symbol:language:false}}</div>
                <hr>
                  <div *ngIf="winnersBundle && currency && currency.Code" class="middle-lottery-information">
                            <button *ngFor="let offer of winnersBundle" class="przycisk medium green rectangle-btn lottery" [ngClass]="{'disabled-btn' : getIsLoading(offer.Name)}"
                                    (click)="buyPackage(
                                   offer.Items[0].Lottery.ID,
                                   'winner',
                                   'Winner',
                                   offer.Items[0].NumberOfEntries,
                                   offer.Rates.OnlinePrice[currency.Code],
                                   offer.PackageID,
                                   offer.Name
                                   );">
                                <div class="cart"></div>
                              <div class="price"><div class="cartIcon"><img *ngIf="brand === 'qiwi'" src="../../../assets/images/navigation/icons/ic-cart.svg" /><img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/ic-cart-winaija.svg" /></div>{{offer.Items[0].NumberOfEntries}} {{ 'lt.lt10' | translate }} {{ 'scratchcards.for' | translate }} {{offer.Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}</div>
                                  <span *ngIf="getIsLoading(offer.Name);" class="spinner"></span>
                            </button>
                    <div class="choose-numbers"><a [routerLink]="[language ? language : 'en', 'winner']">{{ 'lt.lt3' | translate }}</a></div>
                  </div>

              </div>
            </div>
        </div>
      </div>

      <div *ngIf="brand === 'winaija'" class="add-lottery winaijaLotto eurojackpotMenu">
        <a [ngClass]="{'active': activeRouteParameters('/lotteries/winaijalotto', '/lotteries-results/winaijalotto')}"
           [routerLink]="[language ? language : 'en', 'lotteries', 'winaijalotto']">
          <span class="text lottery-eurojackpot">Winaija Lotto</span>
        </a>
        <div class="tooltipBoxWrapper tooltipBox-eurojackpot tooltipBox-winaijaLotto">
            <div class="tooltipBox">
              <div class="tooltipBody">
                  <div class="lottery-time">
                    <img src="../../../assets/images/fancy-banner/clock-grey.svg" />
                    <app-universalcounter [lottery]="42">{{ 'carousel.loading' | translate }}</app-universalcounter>
                  </div>
                <div class="logo-icon logoEurojackpot winaijaLottoLogo"><img src="../../../assets/images/lotteries/winaijalotto/icons/winaijalotto_50x50.png" /></div>
                  <div class="jackpot" *ngIf="winaijaLottoBundle && winaijaLottoBundle[0] && winaijaLottoBundle[0].Rates && currency && currency.Code && jackpotConfig.downloadedData">{{winaijaLottoBundle[0].Rates.TotalJackpotAmount[currency.Code] | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en') | jackpot: (subscriptionsService.countryCodeValue || 'en'):currency.Symbol:language:false}}</div>
                <hr>
                  <div *ngIf="winaijaLottoBundle && currency && currency.Code" class="middle-lottery-information">
                            <button *ngFor="let offer of winaijaLottoBundle" class="przycisk green medium rectangle-btn lottery" [ngClass]="{'disabled-btn' : getIsLoading(offer.Name)}"
                                    (click)="buyPackage(
                                   offer.Items[0].Lottery.ID,
                                   'winaijalotto',
                                   'Winaija Lotto',
                                   offer.Items[0].NumberOfEntries,
                                   offer.Rates.OnlinePrice[currency.Code],
                                   offer.PackageID,
                                   offer.Name
                                   );">
                                <div class="cart"></div>
                                <div class="price"><div class="cartIcon"><img *ngIf="brand === 'qiwi'" src="../../../assets/images/navigation/icons/ic-cart.svg" /><img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/ic-cart-winaija.svg" /></div>{{offer.Items[0].NumberOfEntries}} {{ 'lt.lt10' | translate }} {{ 'scratchcards.for' | translate }} {{offer.Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}</div>
                                  <span *ngIf="getIsLoading(offer.Name);" class="spinner"></span>
                            </button>
                    <div class="choose-numbers"><a [routerLink]="[language ? language : 'en', 'lotteries', 'winaijalotto']">{{ 'lt.lt3' | translate }}</a></div>
                  </div>

              </div>
            </div>
        </div>
      </div>







    </span>
  </div>
  <div class="nav-element nav-scratchcards">
    <a [ngClass]="{'active': activeRouteParameters('/scratchcards', '/scratchcards')}"
       [routerLink]="[language ? language : 'en', 'scratchcards']">
      <span class="ico ico-lotteries ico-lotteries-{{language}}"><img src="../../../assets/images/navigation/icons/Scratchcards/FullColor.svg" width="20px" height="20px" /></span>
      <span class="text">{{ 'awesomeNav.scratchcards' | translate }}</span>
    </a>
  </div>
    <div class="nav-element nav-games ">
        <a [ngClass]="{'active': activeRouteParameters('/games', '/games')}"
           [routerLink]="[language ? language : 'en', 'games']">
            <span class="ico ico-lotteries ico-lotteries-{{language}}"><img src="../../../assets/images/navigation/icons/Games/FullColor.svg" width="20px" height="20px" /></span>
            <span class="text">{{ 'awesomeNav.games' | translate }}</span>
        </a>
    </div>
  <div class="nav-element nav-casino">
    <a [ngClass]="{'active': activeRouteParameters('/casino', '/casino')}"
       [routerLink]="[language ? language : 'en', 'casino']">
      <span class="ico ico-lotteries ico-lotteries-{{language}}"><img src="../../../assets/images/navigation/icons/Casino/FullColor.svg" width="20px" height="20px" /></span>
      <span class="text">{{ 'awesomeNav.casino' | translate }}</span>
    </a>
  </div>
  <div class="nav-element nav-more">
    <div class="nav-more-wrapper">
      <span class="text">{{ 'awesomeNav.more' | translate }} <img class="moreIcon" src="../../../assets/images/navigation/icons/down-arrow.svg" /></span>
      <div class="tooltipBoxWrapper tooltipMoreWrapper">
        <div class="tooltipBox tooltipMore">
          <ul>
            <li><a [routerLink]="[language ? language : 'en', 'packages']">{{ 'awesomeNav.packages' | translate }}</a></li>
            <li><a [routerLink]="[language ? language : 'en', 'lotteries-results']">{{ 'awesomeNav.lottoResults' | translate }}</a></li>
            <li><a [routerLink]="[language ? language : 'en', 'faq']">{{ 'awesomeNav.faq' | translate }}</a></li>
          </ul>
          <div class="brandNewLanguageSwitcher" *ngIf="brand === 'qiwi' && languageSwitcherReadyToShow">
            <app-dw-select
                    [options]="sortValues"
                    [selected]="selected_method_show_name"
                    [image]="true"
                    (change)="switchLanguage($event)"
                    (display)="displayChanger($event)"
                    [displayer]="'brandNewLanguageSwitcher'">
            </app-dw-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <div class="rightSide" #rightSide>
<app-free-spin-button  *ngIf="userData && userData.HasFreeSpins"></app-free-spin-button>
    <div class="nav-element no-border login">
      <span *ngIf="!loggedIn" (click)="goToLogin(loginForm);" class="text">{{ 'awesomeNav.login' | translate }}</span>
        <span *ngIf="loggedIn" class="loggedin">
            <div *ngIf="userDataNameWithGender?.Gender == 'Mr.'" class="gender-man"></div>
            <div *ngIf="userDataNameWithGender?.Gender == 'Ms.' || userDataNameWithGender?.Gender == 'Mrs.'" class="gender-woman"></div>
            <div class="user-dashboard-name">
              <span class="nameWithHi">
                <span class="light" *ngIf="userDataNameWithGender?.FirstName.length <= 10">{{ 'awesomeNav.hi' | translate }}<span class="addChar">,</span></span>
                <span class="firstName"> {{userDataNameWithGender?.FirstName}}</span>
                <span class="lastName"> {{userDataNameWithGender?.LastName}}</span>
                <img class="moreIcon" src="../../../assets/images/navigation/icons/down-arrow.svg" /></span>
            </div>
        <div class="tooltipBoxWrapper userMenuTooltip">
          <div class="tooltipBox userMenuTooltipBody">
            <ul>
            <li class="menu-icon ico-entries" (click)="goToDashboard('my-entries');">{{ 'awesomeNav.myEntries' | translate }}</li>
            <li class="menu-icon ico-bonuses" (click)="goToDashboard('bonuses');">{{ 'awesomeNav.bonuses' | translate }}</li>
            <li class="menu-icon ico-deposit" (click)="triggerDeposit();">{{ 'awesomeNav.deposit' | translate }}</li>
            <li class="menu-icon ico-logout" (click)="logOut($event)">{{ 'awesomeNav.logOut' | translate }}</li>
          </ul>

          </div>
        </div>
        </span>
    </div>
    <div class="nav-element signup">
      <button *ngIf="!loggedIn" class="przycisk orange medium signupButton" (click)="goToRegistration(); step = 1; modalSize = 'modal-md'">{{ 'awesomeNav.signup' | translate }}</button>
      <div *ngIf="loggedIn" class="depositBox" (click)="triggerDeposit();">
        <div class="depositValue">{{ userBalance | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en') }}</div>
          <div class="depositText">{{ 'awesomeNav.deposit' | translate }}</div>
          <div class="depositPlus">+</div>
      </div>
    </div>
    <div class="nav-element cart">
      <a [routerLink]="[language ? language : 'en', 'cart']">
        <button class="przycisk green medium cartButton"><span class="text">{{ 'awesomeNav.cart' | translate }}</span> <img *ngIf="brand === 'qiwi'" src="../../../assets/images/navigation/icons/ic-cart.svg" /><img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/ic-cart-winaija.svg" /><span *ngIf="cartItems" [ngClass]="{'twodigits' : cartItems >= 10}" class="cart_items"><span *ngIf="cartItems >=100">99+</span><span *ngIf="cartItems <= 99">{{cartItems}}</span></span></button>
      </a>
    </div>
  </div>
    <div class="bottomLine"></div>
</div>
<app-free-spin-button *ngIf="(lotteryService.isTablet || lotteryService.isMobile) && (userData && userData.HasFreeSpins)"></app-free-spin-button>
<div *ngIf="lotteryService.isTablet || lotteryService.isMobile" class="awesomeNavigationMobile {{routerForNavbar}}" [ngClass]="{'blocked': userData && userData.Status && userData.Status === '4'}">
  <div class="suspInfo" *ngIf="userData && userData.Status && userData.Status === '4'">{{'nav.suspInfo1' | translate }} <br><span (click)="userService.checkStatus(userData.Status)">{{'nav.suspInfo2' | translate }}</span> </div>
  <div class="leftSide">
    <button *ngIf="!loggedIn" class="przycisk orange small signupButton" (click)="goToRegistration(); step = 1; modalSize = 'modal-md'">{{ 'awesomeNav.signup' | translate }}</button>
    <span *ngIf="loggedIn" class="loggedin">
            <div *ngIf="userDataNameWithGender?.Gender == 'Mr.'" class="gender-man"></div>
            <div *ngIf="userDataNameWithGender?.Gender == 'Ms.' || userDataNameWithGender?.Gender == 'Mrs.'" class="gender-woman"></div>
            <div (click)="goToDashboard('');" class="user-dashboard-name" [ngClass]="{'overflowed' : userDataNameWithGender?.FirstName.length >= 10 }">
              <span class="nameWithHi"><span class="light" *ngIf="userDataNameWithGender?.FirstName.length <= 6">{{ 'awesomeNav.hi' | translate }}, </span>{{userDataNameWithGender?.FirstName}}</span>
            </div>
    </span>
  </div>
  <a routerLink="/" (click)="hideRegModal();" class="centerLogo"></a>
  <div class="rightSide" [ngClass]="{'noItemsInCart' : cartItems < 1}">
    <button *ngIf="!loggedIn" (click)="goToLogin(loginForm);" class="przycisk green small text loginMobile" >{{ 'awesomeNav.login' | translate }}</button>
    <button class="cartMobile" [ngClass]="{'loggedin': loggedIn}" [routerLink]="[language ? language : 'en', 'cart']"><span class="text">{{ 'awesomeNav.cart' | translate }}</span> <img *ngIf="brand === 'qiwi'" src="../../../assets/images/navigation/icons/ic-cart.svg" /><img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/ic-cart-winaija.svg" /><span *ngIf="cartItems" [ngClass]="{'twodigits' : cartItems >= 10}" class="cart_items"><span *ngIf="cartItems >=100">99+</span><span *ngIf="cartItems <= 99">{{cartItems}}</span></span></button>
    <div *ngIf="loggedIn" class="depositBoxMobile" (click)="triggerDeposit();">
      <div *ngIf="currency && currency.Code" class="depositValue">{{ userBalance | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en') }}</div>
      <div class="depositPlus">+</div>
    </div>
  </div>
</div>
<div *ngIf="lotteryService.isTablet || lotteryService.isMobile" class="awesomeNavigationMobileBottom {{routerForNavbar}}">
  <div class="awesomeNavigationMobileBottomLineWrapper {{routerForNavbar}}"><div class="movingElement {{routerForNavbar}}"></div></div>
  <div class="bottomNavElement bottom-lotteries" [ngClass]="{'active': activeRouteParameters('/lotteries', '/lotteries-results')}" [routerLink]="[language ? language : 'en', 'lotteries']"><div class="bottomIco"></div><span class="text">{{ 'awesomeNav.lotteries' | translate }}</span></div>
  <div class="bottomNavElement bottom-scratch" [ngClass]="{'active': activeRouteParameters('/scratchcards', '/scratchcards')}" [routerLink]="[language ? language : 'en', 'scratchcards']"><div class="bottomIco"></div><span class="text">{{ 'awesomeNav.scratch' | translate }}</span></div>
  <div class="bottomNavElement bottom-games" [ngClass]="{'active': activeRouteParameters('/games', '/games')}" [routerLink]="[language ? language : 'en', 'games']"><div class="bottomIco"></div><span class="text">{{ 'awesomeNav.games' | translate }}</span></div>
  <div class="bottomNavElement bottom-casino" [ngClass]="{'active': activeRouteParameters('/casino', '/casino')}" [routerLink]="[language ? language : 'en', 'casino']"><div class="bottomIco"></div><span class="text">{{ 'awesomeNav.casino' | translate }}</span></div>
  <div class="bottomNavElement bottom-more"><app-lotteries-navigation></app-lotteries-navigation></div>
</div>

<app-dialog [(visible)]="ifGameError" class="errorOnScratchWrapp">
  <div class="errorOnScratch">
    <img src="../../../assets/images/faq/ic-404.png" alt="404">
    <h4 *ngIf="error000">{{'scratchcards.error000' | translate}}</h4>
    <h4 *ngIf="error102">{{'scratchcards.error102' | translate}}</h4>
      <h4 *ngIf="error69">{{'errors.069' | translate }}</h4>
    <div class="text-center">
      <a href="#" (click)="closeScratchError($event); " class="btn">OK</a>
    </div>
  </div>
</app-dialog>
<app-jinni-modal [(visible)]="showRegister">
    <app-fresh-registration (loggedIn)="setLogin($event)"></app-fresh-registration>
</app-jinni-modal>
<app-jinni-modal [(visible)]="showLogin">
    <app-login></app-login>
</app-jinni-modal>
<app-jinni-modal [(visible)]="customErrorMessageOnModalVisible">
  <app-jinni-error-modal></app-jinni-error-modal>
</app-jinni-modal>
<app-dialog [(visible)]="showForgetPassword" [(modalSize)]="modalSize" [class.forgot-modal-mobile]="!toggleContent" class="forgot-modal">
  <div class="popup-content forgot-popup fp-1">
    <a href="#" class="close"></a>
    <a [ngClass]="{'active' : step != 3}" class="registerORlogin" (click)="showLogin = true; showForgetPassword = false; modalSize = 'modal-sm modal-sm-wider'">{{ 'modals.login' | translate
      }}
    </a>
    <img src="../../../assets/images/modals/forget/ic_key.svg" alt="">
    <h3>{{ 'forgotpass.fp1' | translate }}</h3>
    <p>{{ 'forgotpass.fp2' | translate }}</p>
    <form #forgotForm="ngForm" (ngSubmit)="resetPasswordForm(forgotForm.value)">
      <input (keydown.space)="$event.preventDefault()" class="input-mail" type="email" placeholder="Email"
             maxlength="{{maxLengthEmail}}"
             [(ngModel)]="email" name="email">
      <div *ngIf="errorVar === '034'" class="notValid checkbox-error active regular">{{ 'ferrors.15' | translate }}</div>
      <div *ngIf="errorVar === '037'" class="notValid checkbox-error active regular">{{ 'ferrors.16' | translate }}</div>
      <div *ngIf="successMessage" class="valid active regular">{{ 'success.18' | translate }}</div>
      <button type="submit" [ngClass]="{'disabled-btn' : isLoadingButton }" class="btn btn-green">
        {{ 'forgotpass.fpbtn' | translate }}
        <span *ngIf="isLoadingButton" class="spinner"></span>
      </button>
    </form>
  </div>
</app-dialog>
<app-dialog [(visible)]="resetPassword" [(modalSize)]="modalSize" class="forgot-modal">
  <div class="popup-content forgot-popup reset-form">
    <a href="#" class="close"></a>
    <div (click)="
                showLogin = true;
                resetPassword = !resetPassword;
                modalSize = 'modal-md';
                error73 = false;
                error12 = false;" class="registerORlogin">{{ 'modals.login' | translate }}
    </div>
    <img src="../../../assets/images/modals/forget/ic_key.svg" alt="">
    <h3 class="mobile-hide">{{ 'resetpass.rs1' | translate }}</h3>
    <h3 class="mobile-show">{{ 'resetpass.rs1m' | translate }}</h3>
    <p>{{ 'resetpass.rs2' | translate }}</p>
    <form #setNewPasswordForm="ngForm" (ngSubmit)="setNewPassword(setNewPasswordForm.value)">
      <input (keydown.space)="$event.preventDefault()" [(ngModel)]="resetToken" name="resetToken" class="input-password" type="password" hidden>
      <input (keydown.space)="$event.preventDefault()" [(ngModel)]="resetEmail" name="email" class="input-password" maxlength="{{maxLengthEmail}}" type="password" hidden>
      <input (keydown.space)="$event.preventDefault()" ngModel name="password" class="input-password" type="password" placeholder="{{ 'resetpass.rs3' | translate }}" #password="ngModel">
      <input (keydown.space)="$event.preventDefault()" ngModel name="repeat_password" class="input-password" type="password" placeholder="{{ 'resetpass.rs4' | translate }}" #repeat_password="ngModel">
      <div *ngIf="error1010" class="notValid checkbox-error active regular">{{ 'errors.1010' | translate }}</div>
      <div *ngIf="error48" class="notValid checkbox-error active regular">{{ 'errors.048' | translate }}</div>
      <div *ngIf="errorDefault" class="notValid checkbox-error active regular">{{ 'errors.Default' | translate }}</div>
      <button type="submit" class="btn btn-green" [disabled]="setNewPasswordForm.value.password !== setNewPasswordForm.value.repeat_password || !setNewPasswordForm.value.password || (setNewPasswordForm.value.password && setNewPasswordForm.value.password.length === 0)">{{ 'static.submit' | translate }}</button>
    </form>
  </div>
</app-dialog>
<app-dialog [(visible)]="resetSuccess && loggedIn" [(modalSize)]="modalSize" class="forgot-modal">
  <div class="popup-content forgot-popup reset-success">
    <a href="#" class="close"></a>
    <a class="registerORlogin"
       (click)=" showLogin = !showLogin; resetSuccess = !resetSuccess; modalSize = 'modal-md'">
      {{ 'modals.login' | translate }}
    </a>
    <img src="../../../assets/images/modals/forget/ic_key2.png" alt="">
    <h3><span class="mobile-show">{{ 'success.s12a' | translate }}</span><span class="mobile-hide">{{ 'success.s12a' | translate }}</span></h3>
    <p><span class="mobile-show">{{ 'success.s12b' | translate }}</span><span class="mobile-hide">{{ 'success.s12b' | translate }}</span></p>
    <div class="">
      <a href="#" (click)="$event.preventDefault; resetSuccess = !resetSuccess; closeModalSuccess();" class="btn">{{ 'static.done' | translate }}</a>
    </div>
  </div>
</app-dialog>
<app-dialog [(visible)]="resetLinkSend" [(modalSize)]="modalSize" class="forgot-modal">
  <div class="popup-content forgot-popup">
    <a href="#" class="close"></a>
    <div (click)="
            showLogin = !showLogin;
            resetLinkSend = !resetLinkSend;
            modalSize = 'modal-md'" class="registerORlogin">{{ 'modals.login' | translate }}
    </div>
    <img src="../../../assets/images/modals/send/ic_send.svg" alt="">
    <h3>{{ 'success.s11a' | translate }}</h3>
    <p>{{ 'success.s12b' | translate }}</p>
    <div class="">
      <a href="#" class="btn">{{ 'static.check' | translate }}</a>
    </div>
  </div>
</app-dialog>
<app-dialog [(visible)]="showRecall" [(modalSize)]="modalSize" class="password-link-send-modal">
  <div class="popup-content forgot-popup reset-success">
    <a [ngClass]="{'active' : step != 3}" class="registerORlogin"
       (click)="showLogin = true; showForgetPassword = false; resetPassword = false; showRecall = false; modalSize = 'modal-sm modal-sm-wider'">{{ 'modals.login' | translate }}
    </a>
    <img src="../../../assets/images/icons/reset-pass.png"/>
    <h3>{{ 'success.s11a' | translate }}</h3>
    <p>{{ 'resetpass.rs5' | translate }} <span *ngIf="lotteryService.isMobile"><br></span> <span class="bold">{{ toSendEmail }}</span></p>
    <p class="reset-success-p" *ngIf="!lotteryService.isMobile">{{ 'resetpass.rs6' | translate }}</p>
    <p class="reset-success-p" *ngIf="lotteryService.isMobile">{{ 'resetpass.rs6Mobile1' | translate }} <br> {{ 'resetpass.rs6Mobile2' | translate }}</p>
    <div class="">
      <a href="#" (click)="$event.preventDefault; showLogin = false; showForgetPassword = false; resetPassword = false; showRecall = false; toggleContentV(true); closeResetModal()" class="btn">{{ 'resetpass.rs8' | translate }}</a>
    </div>
  </div>
</app-dialog>
<app-dialog #restrictBanner [(visible)]="showRestricted || showRestrictedLoginRegister" [(preventClosing)]="prevent" [(modalSize)]="modalSize" class="restrictedarea-modal">
    <div class="inner">
    <img src="../../../assets/images/modals/restricted/ic_restricted.svg"/>
    <h4>{{ 'ferrors.12' | translate }}</h4>
    </div>
</app-dialog>

<app-scratch-checkout [tickets]="checkoutTickets" [id]="checkoutId" [myScratch]="myScratch" [runModal]="scrCheckCnt"></app-scratch-checkout>
<app-dialog [style.width.px] = "frameWidth" [style.height.px]="frameHeight" [(visible)]="showGameModal" [preventClosing]="true" [closeOnlyByButton]="true" #gameModal   modal-size="modal-md" class="game-modal">
    <span class="loader"></span><span class="loading">{{ 'carousel.loading' | translate }}</span>
  <iframe id="game-iframe" width="{{frameWidth}}" height="{{frameHeight}}" #iframe [src]="gameURL | safe" class="{{showIframe}}"></iframe>
</app-dialog>
<div *ngIf="confettiGo === 'go'" class="winnerConfetti {{confettiGo}}">
    <span class="confetti" *ngFor="let item of createRange(100);"></span>
</div>

<app-jinni-tooltip></app-jinni-tooltip>
<app-server-message *ngIf="serverBannerMessage"></app-server-message>
<app-paystack></app-paystack>
